module.exports = __webpack_public_path__ + "static/media/DMA.5c2af483.svg";